import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/interfaces/pcg-table-column.interface';

export class PurchaseOrderListVm {
	poId: number;
	poNumber?: string;
	lineNumber?: string;
	vendorName?: string;
	poValue: number;
	expendituresYtd: number;
	remainingPoBalance: number;
	remainingPoPercent: number;
	belowPOLevelThreshold: boolean;
	purchaseReqNumber?: string;
	purchaseReqPeriod?: string;
	canDelete: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'poId': new UntypedFormControl(0, [...(validators['poId'] ?? []), ...[Validators.required]]),
			'poNumber': new UntypedFormControl(null, [...(validators['poNumber'] ?? []), ...[]]),
			'lineNumber': new UntypedFormControl(null, [...(validators['lineNumber'] ?? []), ...[]]),
			'vendorName': new UntypedFormControl(null, [...(validators['vendorName'] ?? []), ...[]]),
			'poValue': new UntypedFormControl(0, [...(validators['poValue'] ?? []), ...[Validators.required]]),
			'expendituresYtd': new UntypedFormControl(0, [...(validators['expendituresYtd'] ?? []), ...[Validators.required]]),
			'remainingPoBalance': new UntypedFormControl(0, [...(validators['remainingPoBalance'] ?? []), ...[Validators.required]]),
			'remainingPoPercent': new UntypedFormControl(0, [...(validators['remainingPoPercent'] ?? []), ...[Validators.required]]),
			'belowPOLevelThreshold': new UntypedFormControl(false, [...(validators['belowPOLevelThreshold'] ?? []), ...[]]),
			'purchaseReqNumber': new UntypedFormControl(null, [...(validators['purchaseReqNumber'] ?? []), ...[]]),
			'purchaseReqPeriod': new UntypedFormControl(null, [...(validators['purchaseReqPeriod'] ?? []), ...[]]),
			'canDelete': new UntypedFormControl(false, [...(validators['canDelete'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['poId', {"orderId":0,"sortColumn":"poId","searchColumn":"poId","includeInExcel":false,"exportColumns":null,"displayName":"Invoices","isVisible":true,"canSearch":false,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-center","cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['poNumber', {"orderId":1,"sortColumn":"poNumber","searchColumn":"poNumber","includeInExcel":true,"exportColumns":null,"displayName":"PO #","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-left","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['lineNumber', {"orderId":2,"sortColumn":"lineNumber","searchColumn":"lineNumber","includeInExcel":true,"exportColumns":null,"displayName":"Line #","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-left","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['vendorName', {"orderId":3,"sortColumn":"vendorName","searchColumn":"vendorName","includeInExcel":true,"exportColumns":null,"displayName":"Vendor","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-left","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['poValue', {"orderId":4,"sortColumn":"poValue","searchColumn":"poValue","includeInExcel":true,"exportColumns":null,"displayName":"PO Value","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-right","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":true,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['expendituresYtd', {"orderId":5,"sortColumn":"expendituresYtd","searchColumn":"expendituresYtd","includeInExcel":true,"exportColumns":null,"displayName":"Expenditures YTD","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-right","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":true,"isPercent":false,"isEditableField":false,"headerTooltip":"The costs of all Invoices associated to this budget and PO plus the cost of the products on the Request Forms that are shipped for this budget.","isPrint":true,"exportFormat":null}],
			['remainingPoBalance', {"orderId":6,"sortColumn":"remainingPoBalance","searchColumn":"remainingPoBalance","includeInExcel":true,"exportColumns":null,"displayName":"Remaining PO Balance","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-right","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":true,"isPercent":false,"isEditableField":false,"headerTooltip":"PO Value (A) minus the Expenditures YTD (B).","isPrint":true,"exportFormat":null}],
			['remainingPoPercent', {"orderId":7,"sortColumn":"remainingPoPercent","searchColumn":"remainingPoPercent","includeInExcel":true,"exportColumns":null,"displayName":"Remaining PO %","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-right","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":true,"isEditableField":false,"headerTooltip":"Remaining PO Balance (C) divided by PO Value (A).","isPrint":true,"exportFormat":null}],
			['purchaseReqNumber', {"orderId":8,"sortColumn":"purchaseReqNumber","searchColumn":"purchaseReqNumber","includeInExcel":true,"exportColumns":null,"displayName":"Purchase Req #","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['purchaseReqPeriod', {"orderId":9,"sortColumn":"purchaseReqPeriod","searchColumn":"purchaseReqPeriod","includeInExcel":true,"exportColumns":null,"displayName":"Purchase Req Period","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-center","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['canDelete', {"orderId":10,"sortColumn":"canDelete","searchColumn":"canDelete","includeInExcel":false,"exportColumns":null,"displayName":"Delete","isVisible":true,"canSearch":false,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"text-center","cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"You can only delete a PO if it is not associated with any invoices or journal entries.","isPrint":true,"exportFormat":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): PurchaseOrderListVmFromFg {
		return new PurchaseOrderListVmFromFg(fg);
	}
}

export class PurchaseOrderListVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get poId(): number {
		return this.fg.get('poId').value;
	}
	set poId(val) {
		this.fg.get('poId').setValue(val);
	}

	get poNumber(): string {
		return this.fg.get('poNumber').value;
	}
	set poNumber(val) {
		this.fg.get('poNumber').setValue(val);
	}

	get lineNumber(): string {
		return this.fg.get('lineNumber').value;
	}
	set lineNumber(val) {
		this.fg.get('lineNumber').setValue(val);
	}

	get vendorName(): string {
		return this.fg.get('vendorName').value;
	}
	set vendorName(val) {
		this.fg.get('vendorName').setValue(val);
	}

	get poValue(): number {
		return this.fg.get('poValue').value;
	}
	set poValue(val) {
		this.fg.get('poValue').setValue(val);
	}

	get expendituresYtd(): number {
		return this.fg.get('expendituresYtd').value;
	}
	set expendituresYtd(val) {
		this.fg.get('expendituresYtd').setValue(val);
	}

	get remainingPoBalance(): number {
		return this.fg.get('remainingPoBalance').value;
	}
	set remainingPoBalance(val) {
		this.fg.get('remainingPoBalance').setValue(val);
	}

	get remainingPoPercent(): number {
		return this.fg.get('remainingPoPercent').value;
	}
	set remainingPoPercent(val) {
		this.fg.get('remainingPoPercent').setValue(val);
	}

	get belowPOLevelThreshold(): boolean {
		return this.fg.get('belowPOLevelThreshold').value;
	}
	set belowPOLevelThreshold(val) {
		this.fg.get('belowPOLevelThreshold').setValue(val);
	}

	get purchaseReqNumber(): string {
		return this.fg.get('purchaseReqNumber').value;
	}
	set purchaseReqNumber(val) {
		this.fg.get('purchaseReqNumber').setValue(val);
	}

	get purchaseReqPeriod(): string {
		return this.fg.get('purchaseReqPeriod').value;
	}
	set purchaseReqPeriod(val) {
		this.fg.get('purchaseReqPeriod').setValue(val);
	}

	get canDelete(): boolean {
		return this.fg.get('canDelete').value;
	}
	set canDelete(val) {
		this.fg.get('canDelete').setValue(val);
	}
}
